import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, ClipboardList, Bell } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/30612723/pexels-photo-30612723.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function ScoutHomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const firstName = user?.full_name?.split(" ")[0] || "Scout";
  const orgName = user?.organization?.name;

  return (
    <div data-testid="scout-home-page">
      <header className="mb-8">
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-2">Dashboard</div>
        <h1 className="font-display uppercase text-4xl md:text-5xl font-bold tracking-tight">
          Welcome back, {firstName}.
        </h1>
        {orgName && (
          <p className="text-muted-foreground mt-2">
            Reporting to <span className="font-medium text-foreground">{orgName}</span>
          </p>
        )}
      </header>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 relative rounded-xl overflow-hidden border border-border min-h-[280px] flex items-end">
          <img src={HERO_IMG} alt="Player training" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/40 to-transparent" />
          <div className="relative p-8 md:p-10 text-white">
            <div className="text-xs uppercase tracking-[0.3em] text-primary mb-3">// Phase 01</div>
            <div className="font-display uppercase text-3xl md:text-4xl leading-[0.95] max-w-md">
              Your scouting tools<br />are warming up.
            </div>
            <p className="text-white/70 mt-3 max-w-md text-sm">
              Player lookups, match reports and team intel arrive in upcoming phases. For now, keep your account secure.
            </p>
          </div>
        </div>

        <Card className="rounded-xl">
          <CardHeader>
            <CardTitle className="font-display uppercase tracking-tight text-xl flex items-center gap-2">
              <ClipboardList className="h-5 w-5" /> Quick actions
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Button
              variant="outline"
              className="w-full justify-between rounded-none h-12 font-display uppercase tracking-[0.16em] text-sm"
              onClick={() => navigate("/scout/account")}
              data-testid="quick-change-password"
            >
              Change password <ArrowRight className="h-4 w-4" />
            </Button>
            <div className="rounded-md bg-muted/50 p-4 text-sm text-muted-foreground flex gap-3">
              <Bell className="h-4 w-4 mt-0.5 shrink-0" />
              <div>
                More features coming in Phase 2 — leagues, teams and players. <Link to="/scout/account" className="underline">Manage account</Link>.
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
